$(function () {
	// JS detection	
	$('html').removeClass('no-js').addClass('js');

	// TOUCH detection (V1.2)
	if ("ontouchstart" in document.documentElement) {
		// It's a touch screen device.
		$('html').addClass('touch');
		$('html').removeClass('no-touch');
	}

	//DETECT IOS
	$('html').addClass(navigator.userAgent.match(/(iPod|iPhone|iPad)/) ? 'ios' : 'no-ios');
	
	// DETECT ANDROID
	var ua = navigator.userAgent.toLowerCase();
	$('html').addClass(ua.indexOf("android") > -1 ? 'android' : 'no-android');

	// DETECT ANDROID < 4.3	
	if( ua.indexOf("android") >= 0 ) {
		var androidversion = parseFloat(ua.slice(ua.indexOf("android")+8)); 
		if (androidversion < 4.3) {
			$('html').addClass('crapDroid');
		}
	}
	//DETECT MAC
	$('html').addClass((navigator.userAgent.indexOf('Mac') != -1) ? 'mac' : 'no-mac');

	//DETECT CHROME
	$('html').addClass(navigator.userAgent.toLowerCase().indexOf('chrome') > -1 ? 'chrome' : 'no-chrome');	
	
	// DETECT Windows phone	
	if (/windows phone/i.test(navigator.userAgent.toLowerCase()))
	{
		$('html').addClass('windowsMobile');
	}
	
	// PLACEHOLDER SUPPORT (V1.0)
	$('html').addClass(('placeholder' in document.createElement('input')) ? 'placeholder' : 'no-placeholder');
	

	//DETECT DPR/RETINA
	if (window.devicePixelRatio >= 1.25) { }
	if (window.devicePixelRatio >= 1.3) { }
	if (window.devicePixelRatio >= 1.5) { }
	if (window.devicePixelRatio >= 2) { }
});